var map = {
	"./1.png": [
		51,
		3
	],
	"./10.png": [
		52,
		4
	],
	"./2.png": [
		53,
		5
	],
	"./3.png": [
		54,
		6
	],
	"./4.png": [
		55,
		7
	],
	"./5.png": [
		56,
		8
	],
	"./6.png": [
		57,
		9
	],
	"./7.png": [
		58,
		10
	],
	"./8.png": [
		59,
		11
	],
	"./9.png": [
		60,
		12
	],
	"./arrow.png": [
		61,
		13
	],
	"./logo.png": [
		7
	],
	"./win.png": [
		62,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 23;
module.exports = webpackAsyncContext;